import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { CalendarModel, TeamModel, UserVacationModel, VacationDayModel } from '../CalendarModel';
import { CalendarController } from '../CalendarController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { TabHeader } from './TabHeader';
import { TextField } from 'components/input/TextField';
import { TExtraWorkDayType } from 'rpc/VacationRpc';
import { AddVacationScene } from 'scenes/addvacation/view/AddVacationScene';
import { UserVacationStatisticsData } from 'data/UserVacationStatisticsData';
import { UpcomingEventsData } from 'data/UpcomingEventsData';
import { VacationDetailsDialog } from './VacationDetailsDialog';
import { Icon } from '@material-ui/core';

export class CalendarScene extends AScene<Props, CalendarModel, CalendarController> {

    private static readonly MONTH_NAMES: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

    public constructor(props: Props) {
        super(props);

        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    protected createControlller(): CalendarController {
        return new CalendarController(this.props.year, this.props.month);
    }

    public componentWillReceiveProps(props: Props) {
        if (this.props.year == props.year && this.props.month == props.month) {
            return;
        }
        this.controller.onSelectedDatechanged(props.year, props.month);
    }

    private handleSearchChange(newValue: string) {
        this.controller.onSearchTermChanged(newValue);
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<div></div>)
        }

        var y = new Date().getFullYear();

        return (
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <TabHeader bgColor="#009688" height="60px" fontSize="20px" items={[
                    { title: "" + (y - 1), selected: this.props.year == y - 1, url: "/calendar.rsc?year=" + (y - 1) + "&month=" + this.props.month },
                    { title: "" + (y), selected: this.props.year == y, url: "/calendar.rsc?year=" + (y) + "&month=" + this.props.month },
                    { title: "" + (y + 1), selected: this.props.year == y + 1, url: "/calendar.rsc?year=" + (y + 1) + "&month=" + this.props.month }
                ]} />
                <TabHeader bgColor="#26A69A" height="40px" fontSize="16px" items={[
                    { title: CalendarScene.MONTH_NAMES[0], selected: this.props.month == 1, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 1 },
                    { title: CalendarScene.MONTH_NAMES[1], selected: this.props.month == 2, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 2 },
                    { title: CalendarScene.MONTH_NAMES[2], selected: this.props.month == 3, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 3 },
                    { title: CalendarScene.MONTH_NAMES[3], selected: this.props.month == 4, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 4 },
                    { title: CalendarScene.MONTH_NAMES[4], selected: this.props.month == 5, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 5 },
                    { title: CalendarScene.MONTH_NAMES[5], selected: this.props.month == 6, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 6 },
                    { title: CalendarScene.MONTH_NAMES[6], selected: this.props.month == 7, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 7 },
                    { title: CalendarScene.MONTH_NAMES[7], selected: this.props.month == 8, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 8 },
                    { title: CalendarScene.MONTH_NAMES[8], selected: this.props.month == 9, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 9 },
                    { title: CalendarScene.MONTH_NAMES[9], selected: this.props.month == 10, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 10 },
                    { title: CalendarScene.MONTH_NAMES[10], selected: this.props.month == 11, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 11 },
                    { title: CalendarScene.MONTH_NAMES[11], selected: this.props.month == 12, url: "/calendar.rsc?year=" + (this.props.year) + "&month=" + 12 },
                ]} />

                <div style={{ width: '980px', marginTop: '32px' }}>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ flex: 2 }}></div>
                        <div style={{ flex: 1 }}>
                            <TextField startIcon="search" label="" value={this.model.searchTerm} onChange={this.handleSearchChange} />
                        </div>
                    </div>

                    {this.model.vacationCalendarModel.teams.map((item) => {
                        return this.renderTeam(item);
                    })}

                </div>

                <AddVacationScene onVacationAdded={() => {
                    CalendarController.emptyCache();
                    new UserVacationStatisticsData().invalidate();
                    new UpcomingEventsData().invalidate();
                    this.controller.rerender();
                }} />

                <VacationDetailsDialog model={this.model.vacationDetailsDialogModel} controller={this.controller} />
            </div>
        );
    }

    private renderTeam(team: TeamModel) {
        if (team.users.length < 1) {
            return (<div key={"team-" + team.id}></div>)
        }

        return (
            <div key={"team-" + team.id} style={{ width: '100%', marginTop: '32px', display: 'flex', paddingLeft: '3px', paddingRight: '3px', flexDirection: 'column' }}>
                {this.renderTeamHeader(team)}

                {team.collapsed == false && team.users.map((item) => {
                    return this.renderUser(item);
                })}
            </div>
        );
    }

    private renderTeamHeader(team: TeamModel) {
        return (
            <div style={{ display: 'flex' }}>
                <div style={{ flex: 1, cursor: 'pointer', display: 'flex' }} onClick={() => {
                    if (team.collapsed) {
                        this.controller.expandTeam(team.id);
                    } else {
                        this.controller.colleapseTeam(team.id);
                    }
                }}>
                    <Icon style={{ fontSize: '20px', color: '#aaa' }}>{team.collapsed ? "chevron_right" : "expand_more"}</Icon>
                    <div style={{ fontSize: '16px', fontWeight: 900, color: '#ccc', textTransform: 'uppercase', flex: 1, paddingRight: '20px' }}>{team.name}</div>
                </div>
                {this.model.vacationCalendarModel.workdays.map((isWorkDay, index) => {
                    return this.renderTeamHeaderCell(isWorkDay, this.model.vacationCalendarModel.holidays[index], index);
                })}
            </div>
        );
    }

    private renderTeamHeaderCell(isWorkDay: boolean, ewdType: TExtraWorkDayType, index: number) {
        var dayNames: string[] = ["M", "T", "W", "T", "F", "S", "S"]

        var defaultColor = "#888";
        var weekEndColor = "#ccc";
        var holidayColor = "#c00";
        var extraWorkDayColor = "#0c0";

        var color = defaultColor;
        if (ewdType == "HOLIDAY") {
            color = holidayColor;
        } else if (ewdType == "EXTRA_WORK_DAY") {
            color = extraWorkDayColor;
        } else if (!isWorkDay) {
            color = weekEndColor;
        }

        var dayIndex = this.model.vacationCalendarModel.dayIndex[index];

        return (
            <div key={"hd-" + index} style={{ color: color, fontSize: '12px', fontWeight: 900, textAlign: 'center', width: '23px', paddingTop: '5px', paddingBottom: '5px', marginLeft: dayIndex == 1 ? "15px" : "0px" }}>{dayNames[dayIndex - 1]}</div>
        )

    }

    private renderUser(user: UserVacationModel) {
        return (
            <div key={"userDays-" + user.userId} style={{ width: '100%', height: '50px', display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1, alignItems: 'center', paddingRight: '20px', display: 'flex' }}>
                    <div style={{ marginRight: '16px', width: '32px', height: '32px', border: '2px solid #ccc', borderRadius: '50%', backgroundSize: 'cover', backgroundImage: "url('/ProfilePicture?uid=" + user.userId + "')" }}></div>
                    <div style={{ flex: 1, maxWidth: '133px' }}>
                        <div style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '16px', fontWeight: 500, color: '#00796b' }}>{user.userName}</div>
                        <div style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '12px', fontWeight: 400, color: '#888', paddingTop: '3px' }}>{user.position}</div>
                    </div>
                </div>
                {this.renderVacationDays(user.days, user.userId)}
            </div>
        )
    }

    private renderVacationDays(days: VacationDayModel, userId: number) {
        var res: React.ReactNode[] = [];
        console.log(days);

        const d = new Date()
        var currentYear = d.getFullYear()
        var currentMonth = d.getMonth() + 1
        var currentDay = d.getDate() - 1

        for (var i = 0; i < days.ids.length; i++) {
            let isToday: boolean = true
            if (currentYear != this.model.monthSelectorModel.selectedYear || currentMonth != this.model.monthSelectorModel.selectedMont || currentDay != i) {
                isToday = false
            }
            let idx = i;
            var color = 'transparent';
            if (days.types[i] != null) {
                console.log(days.types[i])
                color = days.types[i].color;
            }

            var bgImage = 'none'
            var bgColor = 'transparent';
            if (days.halfDays[i] != null) {
                if (days.halfDays[i] == 'FirstHalf') {
                    bgImage = 'linear-gradient(to right, ' + color + ' 50% , transparent 0 )'
                } else if (days.halfDays[i] == 'SecondHalf') {
                    bgImage = 'linear-gradient(to right, transparent 50%, ' + color + ' 0 )'
                }
            } else if (days.types[i] != null) {
                bgColor = color;
            }

            var opacity = 1.0;
            var holiday = this.model.vacationCalendarModel.holidays[i];
            if (holiday != null) {
                if (holiday == 'HOLIDAY') {
                    opacity = 0.6;
                }
            } else {
                var isWorkDay = this.model.vacationCalendarModel.workdays[i];
                if (!isWorkDay) {
                    opacity = 0.6;
                }
            }


            var dayIndex = this.model.vacationCalendarModel.dayIndex[i];
            res.push(
                <div key={"day-" + i} style={{ color: '#222', fontSize: '12px', fontWeight: isToday ? 900 : 400, textAlign: 'center', verticalAlign: 'middle', lineHeight: '23px', width: '23px', height: '23px', marginLeft: dayIndex == 1 ? "15px" : "0px", backgroundImage: bgImage, backgroundColor: bgColor, opacity: opacity, cursor: "pointer" }}
                    onClick={() => { this.controller.showDetailsDialog(days.ids[idx], this.props.year, userId) }}
                >
                    {i + 1}
                </div>
            );
        }

        return res;
    }


}

export interface Props {

    year: number;
    month: number;

}

export class CalendarSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        var yearStr = historyItem.params['year'];
        var monthStr = historyItem.params['month'];

        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (yearStr != null) {
            yearStr = yearStr.trim();
            try {
                year = parseInt(yearStr);
            } catch (ex) {

            }
        }

        if (monthStr != null) {
            monthStr = monthStr.trim();
            try {
                month = parseInt(monthStr);
            } catch (ex) {

            }
        }

        return <CalendarScene year={year} month={month} />
    }

}